// extracted by mini-css-extract-plugin
export default {"container":"DetailGroupActionTab_container__nLEM0","infoCard":"DetailGroupActionTab_infoCard__G+aae","divider":"DetailGroupActionTab_divider__vEfrb"};